import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Box, Chip } from "@mui/material";
import MUITable from "../../../components/MUITable";

function VendorPropertiesTable(props) {
  const { vendors } = props;
  const properties = vendors.data.vendorProperties || { items: [] };
  const isLoading = vendors.vendorPropertiesAreLoading;

  const [searchParams, setSearchParams] = useState({ search: "" });

  const allItems = properties.items || [];

  const filteredItems = useMemo(() => {
    const term = (searchParams.search || "").trim().toUpperCase();
    if (!term) {
      return allItems;
    }
    return allItems.filter((item) => {
      return (
        (item.name && item.name.toUpperCase().includes(term)) ||
        (item.statusDescription &&
          item.statusDescription.toUpperCase().includes(term)) ||
        (item.propertyManagerName &&
          item.propertyManagerName.toUpperCase().includes(term)) ||
        (item.vendorAcctNum &&
          String(item.vendorAcctNum).toUpperCase().includes(term))
      );
    });
  }, [allItems, searchParams.search]);

  const columns = [
    { field: "name", label: "Name" },
    {
      field: "statusDescription",
      label: "Status",
      render: (row) =>
        row.statusDescription ? (
          <Chip label={row.statusDescription} size="small" variant="outlined" />
        ) : (
          "N/A"
        ),
    },
    { field: "propertyManagerName", label: "Property Manager" },
    { field: "vendorAcctNum", label: "Vendor Acct #" },
  ];

  const handleRowClick = (item) => {
    if (item && item.uuid && item.id && item.propertyManagerId) {
      window.open(
        "/property/" + item.uuid + "/" + item.id + "/" + item.propertyManagerId,
        "_blank"
      );
    }
  };

  return (
    <Box>
      <MUITable
        data={filteredItems}
        columns={columns}
        searchConfig={{
          enabled: true,
          placeholder: "Search by name, status, property manager, account #...",
          initialParams: searchParams,
        }}
        onSearch={setSearchParams}
        sortConfig={{
          enabled: true,
          serverSide: false,
          sortableFields: [
            "name",
            "statusDescription",
            "propertyManagerName",
            "vendorAcctNum",
          ],
        }}
        loadingState={{
          isLoading,
          loadingText: "Loading properties...",
        }}
        emptyState={{
          message: "No active properties are currently billed under this vendor.",
          showWhenEmpty: true,
        }}
        onRowClick={handleRowClick}
      />
    </Box>
  );
}

VendorPropertiesTable.propTypes = {
  vendor: PropTypes.object.isRequired,
  vendors: PropTypes.object.isRequired,
};

function State(state) {
  return {
    vendors: state.vendors,
  };
}

export default connect(State)(VendorPropertiesTable);
